export default __webpack_public_path__ + "static/approval_workflows-611da0e9e70d9ae0779a1b2ed5099810.svg";